import React, {useEffect, useState} from "react";
import { useLocation } from "react-router-dom";

export default function TopNav({ cart }) {
  const location = useLocation();
  const path = location.pathname;
  const [bottomMenuItems, setBottomMenuItems] = useState([]);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/menu-items/bottom-menu`)
      .then(res => res.json())
      .then(data => setBottomMenuItems(data))
      .catch(console.error);
  }, []);

  // Helper to build href for dynamic content pages
  const makeHref = (item) => item.url || `/content/${item.code}`;

  const isActive = (target) => path === target ? "active-link" : "";
  //🛒
  return (
    <>
      <div className="top-left-links">
        <a href="/" className={isActive("/")}><span className="skew-bg"><span className="label-text">Home</span></span></a>
        <a href="/glove-features" className={isActive("/glove-features")}><span className="skew-bg"><span className="label-text">Glove Features</span></span></a>
        <a href="/products" className={isActive("/products")}><span className="skew-bg"><span className="label-text">Buy now</span></span></a>
        {/* {cart.length > 0 && (
        <a href="/cart" className={isActive("/cart")}><span className="skew-bg"><span className="label-text">Cart ({cart.length})</span></span></a>
      )} */}
      </div>

      <div className="mobile-menu" id="mobileMenu">
        <a href="/" className={isActive("/")}>Home</a>
        <a href="/glove-features" className={isActive("/glove-features")}>Glove Features</a>
        <a href="/products" className={isActive("/products")}>Buy now</a>
        <hr />
        <a href="/about-us">About us</a>
        <a href="/contact">Contact</a>
        {bottomMenuItems.map(item => (
          <a key={`mobile-menu-${item.code}`} href={makeHref(item)}>
            {item.title}
          </a>
        ))}
        <hr />
        {cart.length > 0 && (
          <a href="/cart" className={isActive("/cart")}>Cart ({cart.length})</a>
        )}
        {/* TODO: move 🛒 to top right*/}
      </div>

      {/* Bottom Menu  */}
      <div className="menu">
        <a href="/about-us">About us</a>
        <a href="/contact">Contact</a>
        {bottomMenuItems.map(item => (
          <a key={`menu-${item.code}`} href={makeHref(item)}>
            {item.title}
          </a>
        ))}
      </div>
    </>
  );
}